/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Expanded/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import BoardsArchived from './BoardsArchived/index'
import BoardsList from './BoardsList/index'
import DashboardAction from './DashboardAction/index'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import TysiaIconCollapse from 'DesignSystem/Svgs/TysiaIconCollapse/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import UpdateTag from './UpdateTag/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Expanded({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Menu/Expanded",
  onChange
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtColorsNeutral100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.100'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  onChange
  
})
let globalSidebarTogglesIsTasksSidebarOpenChangeData = fromData.useDataChange({ viewPath,
context: 'global',
path: 'sidebar_toggles.is_tasks_sidebar_open',
formatOut: fromHelpers.not,
})
  return (<React.Fragment
>
<div
  data-testid="Expanded.Vertical"
  data-view-path={viewPath}
 style={{'--pt-1-Z2dncGL': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-2-Z2dncGL': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--brc-3-Z2dncGL': dtColorsNeutral200,'--bc-4-Z2dncGL': dtColorsNeutral100}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Expanded.Vertical:1"
  data-view-path={viewPath}
 style={{'--bbc-5-Z2dncGL': dtColorsNeutral200,'--bc-4-Z2dncGL': dtColorsNeutral100,'--pb-2-Z2dncGL': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pl-6-Z2dncGL': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-7-Z2dncGL': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical1}`}
>
<div
  data-testid="Expanded.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Expanded.Vertical:2"
  data-view-path={viewPath}
 className="views-block"
>
<div
  data-testid="Expanded.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 size="normal"
 marginLeft={dtSpaceXs}
 marginRight={dtSpaceXs}
 text="Boards"
/>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="secondary"
 size="small"
 alignSelf="flex-end"
 onClick={onClick}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 weight="medium"
 size="small"
 text="New"
/>
)}
</TysiaButton>
</div>
</div>
<button
  data-testid="Expanded.Vertical:3"
  data-view-path={viewPath}
 onClick={globalSidebarTogglesIsTasksSidebarOpenChangeData}
 {...isHoveredBind}
 className={`views-block ${styles.Vertical2}`}
>
<TysiaIconCollapse
  viewPath={`${viewPath}/TysiaIconCollapse`}
/>
</button>
</div>
</div>
<div
  data-testid="Expanded.Vertical:4"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical3}`}
>
<div
  data-testid="Expanded.Vertical:5"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical4}`}
>
<DashboardAction
  viewPath={`${viewPath}/DashboardAction`}
/>
<BoardsList
  viewPath={`${viewPath}/BoardsList`}
/>
<BoardsArchived
  viewPath={`${viewPath}/BoardsArchived`}
/>
</div>
<UpdateTag
  viewPath={`${viewPath}/UpdateTag`}
/>
</div>
</div>
{children}
</React.Fragment>)
}